import React from "react";
import { SoubourMark } from "./SoubourMark";

export const SiteFooter = () => (
    <footer
        data-testid="site-footer"
        className="border-t hairline mt-32 bg-[var(--sb-page)]"
    >
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-5">
                <div className="font-sport text-2xl tracking-tightest leading-none uppercase">
                    FLOODLIGHT<span className="text-[var(--sb-amber)]">.</span>CLUB
                </div>
                <p className="font-editorial italic text-zinc-400 text-lg mt-4 max-w-md">
                    A commercial operating system for football clubs that take their
                    sponsors as seriously as their starting eleven.
                </p>
            </div>

            <div className="md:col-span-2">
                <div className="text-xs font-bold uppercase tracking-ultra-wide text-zinc-500 mb-4">Product</div>
                <ul className="space-y-2 text-sm text-zinc-300">
                    <li><a className="link-rule" href="/login" data-testid="footer-link-login">Sign in</a></li>
                    <li><a className="link-rule" href="/club" data-testid="footer-link-club">Club admin</a></li>
                    <li><a className="link-rule" href="/sponsor" data-testid="footer-link-sponsor">Sponsor portal</a></li>
                </ul>
            </div>

            <div className="md:col-span-2">
                <div className="text-xs font-bold uppercase tracking-ultra-wide text-zinc-500 mb-4">Company</div>
                <ul className="space-y-2 text-sm text-zinc-300">
                    <li><span className="text-zinc-500">About</span></li>
                    <li><span className="text-zinc-500">Pricing</span></li>
                    <li><span className="text-zinc-500">Contact</span></li>
                </ul>
            </div>

            <div className="md:col-span-3 md:text-right">
                <div className="text-xs font-bold uppercase tracking-ultra-wide text-zinc-500 mb-4">Parent</div>
                <div className="inline-flex items-center gap-3 border hairline px-4 py-3">
                    <SoubourMark size={20} />
                    <div className="text-left">
                        <div className="font-editorial italic text-zinc-300 text-sm leading-tight">powered by Soubor Applications Ltd</div>
                        <div className="text-xs text-zinc-500">floodlight.club</div>
                    </div>
                </div>
            </div>
        </div>
        <div className="border-t hairline">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-zinc-500">
                <div>© {new Date().getFullYear()} Soubor Applications Ltd. Registered in England.</div>
                <div className="flex items-center gap-6">
                    <span>Made for matchday</span>
                    <span className="inline-flex items-center gap-2">
                        <span className="kpi-pip" style={{ background: "var(--sb-amber)" }} />
                        all systems live
                    </span>
                </div>
            </div>
        </div>
    </footer>
);

export default SiteFooter;
